<template>
  <div>
    <meta name="viewport" content="width=device-width, user-scalable=no, minimum-scale=1.0, maximum-scale=1.0">
    <div id="camera-container" class="d-flex justify-content-center align-items-center">
      <div id="viewport" class=""">
        <video ref="video" id="video" autoplay="" style="display:none" webkit-playsinline="true" playsinline="true" muted=""></video>
        <canvas ref="canvas" id="canvas"></canvas>
        <div  id="controls" class="p-3">
          <div>
            <button id="snap" v-on:click="closeCamera()" class="btn btn-danger rounded-circle btn-sm">
              <i class="fa fa-times" aria-hidden="true"></i>
            </button>
          </div>
          <div>
            <button id="snap" v-on:click="capture()" class="btn btn-primary rounded-circle">
              <i class="fa fa-camera" aria-hidden="true"></i>
            </button>
          </div>
          <div>
            <div class="dropdown dropup" id="switchCamera" v-if="devices.length > 1">
              <a class="btn btn-secondary dropdown-toggle rounded-circle btn-sm" href="javascript:void(0)" @click="toggleDropdown">
                <i class="fa fa-retweet" aria-hidden="true"></i>
              </a>
              <div class="dropdown-menu dropdown-menu-right">
                <a v-for="device in devices" class="dropdown-item" href="javascript:void(0)" v-on:click="changeCamera(device.deviceId)">{{device.label}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <canvas ref="photo" id="photo" class="hidden"></canvas>
    <ConfirmSave v-bind.sync="{saveImage: saveImage}"></ConfirmSave>
    <ConfirmAnother v-bind.sync="{guest: guest}"></ConfirmAnother>
  </div>
</template>

<script>
import ConfirmSave from './modals/ConfirmSave.vue';
import ConfirmAnother from './modals/ConfirmAnother.vue';

import moment from 'moment';
moment.parseTwoDigitYear = function (yearString) {
  return parseInt(yearString) + (parseInt(yearString) > parseInt(moment().format("YY")) ? 1900 : 2000);
}
import { ImageCapture } from 'image-capture';

export default {
  name: 'Camera',
  data: () => ({
    video: null,
    canvas: null,
    photo: null,
    devices: [],
    device: {
      id: null
    },
    messages:[],
    tries: 0,
    image: ""
  }),
  props: ['failedFields', 'guest', 'camera', 'changeDOB'],
  created(){
    this.$emit('update:failedFields', [])
    document.querySelector('head meta[name="viewport"]').setAttribute('content', 'width=device-width,initial-scale=1');
  },
  components: {
    ConfirmSave, ConfirmAnother
  },
  mounted(){
    document.querySelector('body').style="overflow:hidden;"
    this.video = this.$refs.video;
    this.canvas = this.$refs.canvas;
    document.addEventListener("click", this.closeDropdown);

    if(navigator.mediaDevices && navigator.mediaDevices.getUserMedia && navigator.mediaDevices.enumerateDevices) {

      navigator.mediaDevices.enumerateDevices()
      .then(devices => {
        if(devices.find(d => d.kind == 'videoinput' && d.label.toLowerCase().indexOf("back") > -1)){
          return devices.filter(d => d.kind == 'videoinput' && d.label.toLowerCase().indexOf("back") > -1)
        }
        return devices.filter(d => d.kind == 'videoinput');
      })
      .then(devices => {
        this.devices = devices;
        if(this.devices && this.devices.length){
          this.device.id = this.devices[0].deviceId;

          let constraints = {video: { deviceId: this.device.id,  width: { exact: 1280}, height: {exact: 720}, frameRate: {ideal: 30, max: 30} }, audio: false };

          this.init(constraints);
          this.video.width = 1280;
          this.video.height = 720;
          window.addEventListener('resize', this.resize);

          if (!('createImageBitmap' in window)) {
            window.createImageBitmap = async function(blob) {
              return new Promise((resolve,reject) => {
                let img = document.createElement('img');
                img.addEventListener('load', function() {
                    resolve(this);
                });
                img.src = URL.createObjectURL(blob);
              });
            }
          }
        }
      })
    }
  },
  beforeDestroy() {
    document.querySelector('body').removeAttribute('style')
    window.removeEventListener('resize', this.resize);
    document.querySelector('head meta[name="viewport"]').setAttribute('content', 'width=device-width,initial-scale=1');
    this.video.srcObject.getTracks().forEach(t => t.stop());
  },
  methods: {
    init(constraints){
      navigator.mediaDevices.getUserMedia(constraints).then(stream => {
        this.video.srcObject = stream;
        const track = stream.getVideoTracks()[0];
        this.imageCapture = new ImageCapture(track);
        this.video.play();
        this.resize();
        this.play();
      })
    },
    toggleDropdown: function(e){
      const link = e.target;
      const menu = link.nextSibling;

      menu.classList.toggle("show");
      return;
    },
    closeDropdown: function(e){
      const dropdown = document.querySelector('#switchCamera');
      if(dropdown && !dropdown.querySelector("a").contains(e.target)){
        dropdown.querySelector("a").contains(e.target) || dropdown.querySelector('.dropdown-menu').classList.remove("show");
      }
    },
    saveBlob(blob, fileName) {
      var a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";

      a.href = blob;
      a.download = fileName;
      a.click();
    },
    draw(canvas, image, filter = null) {
      let context = canvas.getContext("2d");
      let scale = Math.max(canvas.height / image.height, canvas.width / image.width)
      let x = (canvas.width / 2) - (image.width / 2) * scale;
      let y = (canvas.height / 2) - (image.height / 2) * scale;
      //context.filter = filter;
      context.drawImage(image, x, y, image.width * scale, image.height * scale);
      //make it grayscale
      if(filter){
        let imgPixels = context.getImageData(0, 0, canvas.width, canvas.height);

        for(let a = 0; a < imgPixels.height; a++){
          for(let b = 0; b < imgPixels.width; b++){
            var i = (a * 4) * imgPixels.width + b * 4;
            var avg = (imgPixels.data[i] + imgPixels.data[i + 1] + imgPixels.data[i + 2]) / 3;
            imgPixels.data[i] = avg;
            imgPixels.data[i + 1] = avg;
            imgPixels.data[i + 2] = avg;
          }
        }
        context.putImageData(imgPixels, 0, 0, 0, 0, imgPixels.width, imgPixels.height);
      }
    },
    drawRectangle(canvas, color){
      let c = canvas.getContext('2d');
      let w = canvas.width;
      let h = canvas.height;
      c.strokeStyle = color;
      c.lineWidth = 5;
      if(w > h){
        if(w / h <= 3 / 2){
          c.strokeRect(20, (h - (w-40) / 3 * 2) / 2, w-40, (w-40) / 3 * 2);
        }else{
          c.strokeRect((w - (h-40) * 3 / 2) / 2, 20, (h-40) * 3 / 2, h-40);
        }
      }else{
        if(h / w <= 3 / 2){
          c.strokeRect( (w - (h-40) / 3 * 2) / 2, 20, (h-40) / 3 * 2, h-40);
        }else{
          c.strokeRect(20, (h - (w-40) * 3 / 2) / 2, w-40, (w-40) * 3 / 2);
        }
      }
    },
    writeText(canvas, text, font, color, x, y, align="left"){
      let c = canvas.getContext('2d');
      c.textAlign = align;
      c.fillStyle = color;
      c.font = font;
      c.fillText(text, x, y);
    },
    saveImage(){
      const formData = new FormData();
      formData.set('image', this.image);
      formData.set('booking._id', this.guest.booking._id)
      if(this.guest._id){
        formData.set('guest._id', this.guest._id)
      }

      return fetch(process.env.VUE_APP_API + '/guests/mrz', {
        method: 'post',
        credentials: 'include',
        headers: {
          'CSRF-Token': this.$csrf
        },
        body: formData
      })
      .then(response => response.json())
      .then(response => {
        if(response.error){
          alert(JSON.stringify(response.error.message))
        }else{
          if(!this.guest._id){
            this.guest._id = response._id;
            this.$bvModal.show('confirmAnotherModal')
          }else{
            return this.$router.push('/' + this.$i18n.locale + '/' + this.$t('bookings') + '/' + this.guest.booking._id);
          }
        }
      })
    },
    capture() {
      this.tries += 1;
      let photo = this.$refs.photo;
      let context = photo.getContext("2d");

      this.video.pause();
      this.messages = [];

      this.imageCapture.takePhoto({
        imageWidth: this.video.width,
        imageHeight: this.video.height
      })
      .then(blob => createImageBitmap(blob))
      .then(imageBitmap => {
        photo.height = 720;
        photo.width = imageBitmap.width * photo.height / imageBitmap.height;

        if(this.canvas.height > this.canvas.width){
          photo.width = 720;
          photo.height = imageBitmap.height * photo.width / imageBitmap.width;
        }

        this.draw(photo, imageBitmap, 'grayscale(100%)');
        this.image = photo.toDataURL("image/jpeg", 1.0);


        //this.saveBlob(this.image, 'test.jpg');

        if(!this.guest._id){
          return this.detect();
        }else{
          return this.saveImage();
        }
      })
    },

    detect(){
      const formData = new FormData();
      formData.set('image', this.image);

      return fetch(process.env.VUE_APP_API + '/mrz/image', {
        method: 'post',
        credentials: 'include',
        headers: {
          'CSRF-Token': this.$csrf
        },
        body: formData
      })
      .then(response => {
        return response.json();
      })
      .then(response => {
        this.video.play();
        this.play();
        if(response.error){
          this.messages = response.error.messages.image[0].split('\n');
          if(this.tries >= 3){
            this.$bvModal.show('confirmSaveModal')
            return;
          }
        }else{
          this.guest.name.last = response.fields[0];
          this.guest.name.first = response.fields[1];
          this.guest.country = response.fields[3];
          this.guest.dob.year = Number(response.fields[4].substring(0,2)) ? moment(Number(response.fields[4].substring(0,2)), "YY").format("YYYY") : null;
          this.guest.dob.month = Number(response.fields[4].substring(2,4));
          this.guest.dob.day = Number(response.fields[4].substring(4,6));
          this.guest.gender = response.fields[6];
          this.guest.document.type = response.fields[7].replace("1", "I").substring(0,1);
          this.guest.document.number = response.fields[8];

          //izračunaj turistično takso
          this.changeDOB();
          this.$emit('update:failedFields', response.failed)

          console.log(this.guest);
          this.closeCamera();
        }
      })
    },

    play(){
      let c = this.canvas.getContext('2d');
      c.save();
      let v = this.video;
      if(v.paused || v.ended) return false;

      let w = this.canvas.width;
      let h = this.canvas.height;

      this.draw(this.canvas, this.video)
      this.drawRectangle(this.canvas, "#00FF00");

      if(w > h){
        this.writeText(this.canvas, "Osebno izkaznico v okvir", "15px Arial", "#00FF00", w/2, h/2, "center");
      }else{
        c.rotate(Math.PI / 2);
        this.writeText(this.canvas, "Osebno izkaznico v okvir", "15px Arial", "#00FF00", h/2, -w/2, "center");
      }

      if(this.messages.length){
        let line = 50;
        this.messages.forEach(message => {
          if(w > h){
            this.writeText(this.canvas, message, "16px Arial", "#FF0000", 60, line)
          }else{
            this.writeText(this.canvas, message, "16px Arial", "#FF0000", 60, -(w - line))
          }
          line += 20;
        })
      }
      c.restore();

      setTimeout(this.play,20);
    },
    closeCamera(){
      this.video.pause();
      this.camera.show = false;
    },
    changeCamera(deviceId) {
      this.video.srcObject.getTracks().forEach(t => t.stop());
      this.init({video: {deviceId: { exact: deviceId}, width: { exact: 1280}, height: {exact: 720}, frameRate: {ideal: 30, max: 30}  }, audio: false});
    },
    resize(){
      let container = document.getElementById("camera-container");
      let controls = document.getElementById("controls");

      if(container.clientHeight < container.clientWidth){
        this.video.width = 1280;
        this.video.height = 720;
        this.canvas.width = container.clientWidth - controls.clientWidth <= this.video.width ? container.clientWidth - controls.clientWidth : this.video.width;
        this.canvas.height = container.clientHeight <= this.video.height ? container.clientHeight : this.video.height;
      }else{
        this.video.width = 720;
        this.video.height = 1280;
        this.canvas.width = container.clientWidth <= this.video.width ? container.clientWidth : this.video.width;
        this.canvas.height = container.clientHeight - controls.clientHeight <= this.video.height ? container.clientHeight - controls.clientHeight : this.video.height;
      }
    }
  }
}
</script>

<style>
#camera-container{
  top:0;
  left:0;
  position:fixed;
  height:100%;
  width:100%;
  z-index:1021;
  display:block;
  background-color:#696969;
  overflow: hidden;
}

#viewport{
  display: flex;
  flex-direction: row;
  box-shadow: 0px 0px 0px 2px #000000;
  background-color:#221F1F
}

#controls{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}

@media only screen and (orientation: portrait) {
  #viewport{
    flex-direction: column;
  }
  #controls{
    flex-direction: row-reverse

  }
  #controls button{
    transform: rotate(90deg);
  }
  .dropdown.dropup{
    transform: rotate(90deg);
  }
}
</style>


<i18n>
{
  "en": {
    "bookings": "bookings"
  },
  "sl": {
    "bookings": "rezervacije"
  }
}
</i18n>
